import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Bar } from "react-chartjs-2";
import Button from "react-bootstrap/Button";
import Bunexe_service from "../Bunexe_service";

const CATEGORIES = [
  {
    id: "9af",
    label: "9 A.F",
    endpoint: "/eleve/dep/statglobal",
    title: "Statistiques pour la Neuvième A.F",
    variant: "outline-primary",
  },
  {
    id: "ns2",
    label: "NS. II",
    endpoint: "/ns2/dep/statns2global",
    title: "Statistiques pour le N.S II",
    variant: "outline-warning",
  },
  {
    id: "ns3",
    label: "NS. III",
    endpoint: "/ns3/dep/statns3global",
    title: "Statistiques pour le N.S III",
    variant: "outline-info",
  },
  {
    id: "ns4",
    label: "NS. IV",
    endpoint: "/ns4/dep/statns4global",
    title: "Statistiques pour le N.S IV",
    variant: "outline-warning",
  },
  {
    id: "eni_nouv",
    label: "ENI/NOUV",
    endpoint: "/eni/dep/stateniglobal",
    title: "Statistiques pour ENI / Nouveau",
    variant: "outline-primary",
  },
  {
    id: "eni_cap",
    label: "ENI/CAP",
    endpoint: "/enic/dep/statenicglobal",
    title: "Statistiques pour ENI / Capiste",
    variant: "outline-danger",
  },
  {
    id: "perm_ph",
    label: "PERM. PHILO",
    endpoint: "/permph/dep/statglobal",
    title: "Statistiques pour le bac Permanent Philo",
    variant: "outline-success",
  },
  {
    id: "perm_ns",
    label: "PERM. NS IV",
    endpoint: "/permns/dep/statglobal",
    title: "Statistiques pour le bac Permanent NS IV",
    variant: "outline-danger",
  },
];

const Stat_global = () => {
  const [reponse, setReponse] = useState([]);
  const [activeCategory, setActiveCategory] = useState(CATEGORIES[3]); // Par défaut NS. IV

  const fetchStatData = useCallback((category) => {
    setActiveCategory(category);
    fetch(`${Bunexe_service.url}${category.endpoint}`)
      .then((res) => res.json())
      .then((data) => setReponse(Array.isArray(data) ? data : []))
      .catch((err) =>
        console.error("Erreur de chargement des statistiques:", err),
      );
  }, []);

  useEffect(() => {
    fetchStatData(CATEGORIES[3]);
  }, [fetchStatData]);

  // Tri alphabétique inverse par nom de département
  const sortedData = useMemo(() => {
    return [...reponse].sort((a, b) => b.dept.localeCompare(a.dept));
  }, [reponse]);

  // Calcul du total d'inscrits
  const effectifTotal = useMemo(() => {
    return reponse.reduce((acc, curr) => acc + (curr.valeur || 0), 0);
  }, [reponse]);

  // Structuration des données Chart.js
  const chartData = useMemo(() => {
    return {
      labels: sortedData.map((item) => item.dept),
      datasets: [
        {
          label: "Inscrits par Département",
          data: sortedData.map((item) => item.valeur),
          backgroundColor: [
            "rgba(255, 99, 132, 0.2)",
            "rgba(54, 162, 235, 0.2)",
            "rgba(255, 206, 86, 0.2)",
            "rgba(75, 192, 192, 0.2)",
            "rgba(153, 102, 255, 0.2)",
            "rgba(255, 159, 64, 0.2)",
            "rgba(254, 98, 132, 0.2)",
            "rgba(40, 100, 200, 0.2)",
            "rgba(255, 206, 86, 0.2)",
            "rgba(75, 152, 220, 0.2)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
          ],
          borderWidth: 1,
        },
      ],
    };
  }, [sortedData]);

  const chartOptions = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
    maintainAspectRatio: false,
  };

  return (
    <div className="container mt-3">
      <div className="d-flex flex-wrap justify-content-center mb-3">
        {CATEGORIES.map((cat) => (
          <Button
            key={cat.id}
            variant={
              activeCategory.id === cat.id
                ? cat.variant.replace("outline-", "")
                : cat.variant
            }
            className="mr-1 mb-1 btn-sm"
            onClick={() => fetchStatData(cat)}
          >
            {cat.label}
          </Button>
        ))}
      </div>

      <h2 className="text-center">{activeCategory.title}</h2>
      <h6 className="text-center text-muted mt-2">
        ({effectifTotal}) Candidats Inscrits
      </h6>

      <div className="row mt-4">
        <div className="col-12 col-md-7 mb-4">
          <Bar data={chartData} height={320} options={chartOptions} />
        </div>
        <div className="col-12 col-md-5">
          <table className="table table-striped table-hover">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Département</th>
                <th scope="col">Qte.</th>
              </tr>
            </thead>
            <tbody>
              {reponse.map((r, index) => (
                <tr key={index}>
                  <td>{r.dept}</td>
                  <td>{r.valeur}</td>
                </tr>
              ))}
              <tr className="font-weight-bold table-active">
                <td>Effectif Global</td>
                <td>{effectifTotal}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Stat_global;
